// 设置当前导航高亮是第几个
export const setIndex = 'setIndex'
// 修改风格筛选结果
export const setStyleId = 'setStyleId'
// 修改出品方筛选结果
export const setProducerId = 'setProducerId'
// 这是获取结果 loading
export const setResultLoading = 'setResultLoading'
// 修改片单id
export const setId = 'setId'
// 修改风格列表展开状态
export const setStyleListStatus = 'setStyleListStatus'
// 修改出品方列表展开状态
export const setProducerListStatus = 'setProducerListStatus'
// 设置当前排序方式
export const setOrder = 'setOrder'

export default {
  [setIndex](state: any, index: any) {
    state.index = index
  },
  [setStyleId](state: any, keyword: any) {
    state.styleId = keyword
  },
  [setProducerId](state: any, keyword: any) {
    state.producerId = keyword
  },
  [setResultLoading](state: any, status: any) {
    state.resultLoading = status
  },
  [setId](state: any, id: any) {
    state.id = id
  },
  [setId](state: any, id: any) {
    state.id = id
  },
  [setStyleListStatus](state: any, status: any) {
    state.styleListOpen = status
  },
  [setProducerListStatus](state: any, status: any) {
    state.producerListOpen = status
  },
  [setOrder](state: any, order: any) {
    state.order = order
  },
}
